import React from "react";

export const QualtricsPlaceHolder: React.FC = () => {
  return <div id="qualtrics-placeholder" className="qualtrics-placeholder"/>;
};
